// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/survival-equipment.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/survival-equipment/survival-equipment.js';

mount([g0]);
